import { useAnimateIconTranslationRight } from '@dreamstack/feature-components/src/layout/AnimateIconTranslation'
import { GridWithGaps } from '@dreamstack/feature-components/src/layout/MainGrid'
import { SimpleMuiButton } from '@dreamstack/feature-components/src/layout/SimpleMuiButton'
import {
  BodyText,
  Custom_Block_Map_Font_H1,
} from '@dreamstack/feature-components/src/layout/Texts'
import { propertiesOverviewOtherLocaleUrls } from '@dreamstack/feature-components/src/property/routing/getPropertyUrl'
import { useLocale, useTranslation } from '@dreamstack/i18n'
import { motion } from 'framer-motion'
import Image from 'next/image'
import Link from 'next/link'
import type { FunctionComponent } from 'react'

export const AllPropertyGermanyMap: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const t = useTranslation()
  const { onHoverStart } = useAnimateIconTranslationRight()
  const locale = useLocale()

  return (
    <GridWithGaps>
      <div className="relative col-span-full">
        <div className="float-left absolute w-full top-1/4 md:w-3/4 ml:top-1/3">
          <BodyText>{t('accentro:germanyMapLanding.Heading1')}</BodyText>
          <Custom_Block_Map_Font_H1 className="mt-px-16 mb-px-40 ml:mt-0">
            {t('accentro:germanyMapLanding.Heading2')}
          </Custom_Block_Map_Font_H1>

          <Link
            href={propertiesOverviewOtherLocaleUrls[locale].url}
            passHref
            legacyBehavior
          >
            <motion.a onHoverStart={onHoverStart}>
              <SimpleMuiButton color="primary" variant="contained">
                {t('accentro:germanyMapLanding.Cta')}
              </SimpleMuiButton>
            </motion.a>
          </Link>
        </div>
        <div className="float-right relative ml-auto w-full md:w-3/4 -z-[1]">
          <div className="relative h-[400px] md:h-[600px] ml:h-[800px]">
            <Image
              src={`/static/images/germany-map.png`}
              alt="Map of Germany"
              fill
              className="object-contain"
            />
          </div>
        </div>
      </div>
    </GridWithGaps>
  )
}
